import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PECONN_TOKEN,
  PeConnAccessToken,
  ROUTES_DASHBOARD_ERROR,
  ROUTES_MANAGEMENT,
  ROUTES_PENDING,
  ROUTES_SIGNUP,
} from '../shared/constants';

import { map } from 'rxjs/operators';
import { EyefinityDashboardStatusTypeEnum } from './eyefinity-dashboard-status-type.enum';
import { AuthenticationService } from '../data-services/authentication/authentication.service';
import { InterceptorTypeEnum } from '../data-services/authentication/InterceptorType.enum';
import { SignupStatusService } from '../data-services/signup-status/signup-status.service';
import { CompanyService } from '../data-services/company/company.service';

@Injectable({
  providedIn: 'root',
})
export class EyefinityDashboardService {
  constructor(
    private signupStatus: SignupStatusService,
    private companyService: CompanyService,
    private authService: AuthenticationService,
  ) {}

  /**
   * returns true if an eyefinity token exists in local storage
   */
  hasToken(): boolean {
    return this.authService.hasTokenInStorage(PECONN_TOKEN);
  }

  /**
   * removes the eyefinity token from local storage
   */
  removeEyefinityTokenFromStorage(): void {
    this.authService.removeFromStorage(PECONN_TOKEN);
  }

  /**
   * Sets app interceptor to type Eyefinity (may not be needed in the future) and tries to get an access token
   */
  getPeConnAccessToken(): PeConnAccessToken {
    return this.authService.getPeConnAccessToken();
  }

  /**
   * given an efan we attempt to determine what page a user should be redirected to based on their status
   * @param efan
   */
  getInitialRoute$(efan: string): Observable<string> {
    return this.signupStatus.checkForEyefinityDashboardStatus$(efan).pipe(
      map((status) => {
        this.authService.setInterceptorType(InterceptorTypeEnum.EYEFINITY);
        switch (status) {
          case EyefinityDashboardStatusTypeEnum.newSignup: {
            return ROUTES_SIGNUP;
          }
          case EyefinityDashboardStatusTypeEnum.pendingSignup: {
            return ROUTES_PENDING;
          }
          case EyefinityDashboardStatusTypeEnum.omiManage: {
            return ROUTES_MANAGEMENT;
          }
          default: {
            console.error('Unable to determine users status');
            return ROUTES_DASHBOARD_ERROR;
          }
        }
      }),
    );
  }
}
